/**
 * Actions for Maintenance Mode (shown when Sparx Web is offline or about to
 * go offline for maintenance) and for when there is a Server error
 */

export const REQUEST_MAINTENANCE = 'REQUEST_MAINTENANCE';
export const SET_MAINTENANCE_MODE = 'SET_MAINTENANCE_MODE';
export const SERVER_ERROR = 'SERVER_ERROR';

/**
 * Action creator to request that Sparx Web is put immediately into maintenance
 * mode, showing the Maintenance View
 */
export function requestMaintenance() {
    return { type: REQUEST_MAINTENANCE };
}

/**
 * Action creator to notify the user that the app will go into maintenance mode
 * in the near future, or to turn maintenance mode off
 * @param mode if true, the app is going into maintenance mode, if false it
 * is leaving maintenance mode
 * @param timeout the number of seconds before maintenance mode starts
 */
export function setMaintenanceMode(mode, timeout) {
    return { type: SET_MAINTENANCE_MODE, mode, timeout };
}

/**
 * Action to put Sparx Web into server error mode. This is where there is a
 * major issue with the server, so Sparx Web should just shown the server
 * error page.
 */
export function serverError() {
    return { type: SERVER_ERROR };
}
